import defaultAPI from './defaultAPI';

class GetPA extends defaultAPI{
    constructor(targetPathInput = null, dataInput = null){   
        super( targetPathInput, dataInput );
    }
    
    get getData() {
		const queryParams = new URLSearchParams(window.location.search)
		
		let params = ["false", "false"];
		
		if( queryParams.get('h') == "active" ){
			params[0] = "active";
		}
		
		if( queryParams.get('wip') == "active" ){
			params[1] = "active";
		}
		
		return new Promise((resolve, reject) => {
			fetch("https://tjtrice.co.uk:9000/GetPA?h=" + params[0] + "&wip=" + params[1])
			.then(res => res.json())
			.then(
				(result) => {
					resolve( result );
				},
				// Note: it's important to handle errors here
				// instead of a catch() block so that we don't swallow
				// exceptions from actual bugs in components.
				(error) => {
				  resolve( "error" );
				}
			)
		});
    }

    DummyData(){
        console.log(this.data);
        this.RequestData();
        return [
            { 'itemId': 1, 'image': 'logo.svg', 'previewImage': '/path/to/img', 'date': 20010203, 'title': "title", 'description': "Some description of the item", 'relation': [3, 4], 'category': [1, 3] },
        ];
    }
}

export default GetPA;